import Vue from 'vue'
import Router from 'vue-router'
import i18n from './plugins/languages/i18n'
import permissions from '@/plugins/permissions'
import store from './store'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,

  routes: [
    {
      path: '/',
      name: 'home',

      components: {
        view: () => import('./views/HomeLanding')
      },

      meta: {
        requiresUserAuth: true,
        requiresAcademyAuth: true
      }
    },

    {
      path: `/${i18n.t('rPaths.updatingLicence')}`,
      name: 'updatingLicence',

      components: {
        view: () => import('./views/UpdatingLicence')
      },
      meta: {
        requiresUserAuth: true,
        requiresAcademyAuth: true
      }
    },

    {
      path: `/${i18n.t('rPaths.academy')}/:subject`,
      name: 'academy',

      // Children routes
      children: [
        {
          path: ':subedition',
          name: 'academyChild1',
          components: {
            view: () => import('./views/EditionSection')
          },

          meta: {
            isEdition: 'academy',
            requiresUserAuth: true,
            requiresAcademyAuth: true
          }
        },

        {
          path: ':id/:subedition',
          name: 'academyChild2',

          children: [
            {
              path: ':subitem',
              name: 'academysubChild1',
              components: {
                view: () => import('./views/EditionSection')
              },

              meta: {
                isEdition: 'academy',
                requiresUserAuth: true,
                requiresAcademyAuth: true
              }
            },

            {
              path: ':subid/:subitem',
              name: 'academysubChild2',
              components: {
                view: () => import('./views/EditionSection')
              },

              meta: {
                isEdition: 'academy',
                requiresUserAuth: true,
                requiresAcademyAuth: true
              }
            }
          ],

          components: {
            view: () => import('./views/EditionSection')
          },

          meta: {
            isEdition: 'academy',
            requiresUserAuth: true,
            requiresAcademyAuth: true
          }
        }
      ],

      components: {
        view: () => import('./views/EditionSection')
      },

      meta: {
        isEdition: 'academy',
        requiresUserAuth: true,
        requiresAcademyAuth: true
      }
    },

    {
      path: `/${i18n.t('rPaths.accessDenied')}`,
      name: 'accessDenied',

      components: {
        view: () => import('./views/AccessDenied')
      },

      meta: {
        requiresUserAuth: true,
        requiresAcademyAuth: true
      }
    },

    {
      path: `/${i18n.t('rPaths.account')}/:subject`,
      name: 'account',

      // Children routes
      children: [
        {
          path: ':subedition',
          name: 'accountChild1',
          components: {
            view: () => import('./views/EditionSection')
          },

          meta: {
            isEdition: 'account',
            requiresUserAuth: true,
            requiresAcademyAuth: true
          }
        }
      ],

      components: {
        view: () => import('./views/EditionSection')
      },

      meta: {
        isEdition: 'account',
        requiresUserAuth: true,
        requiresAcademyAuth: true
      }
    },

    {
      path: `/${i18n.t('rPaths.asset')}/:id/:subject`,
      name: 'asset',

      // Children routes
      children: [
        {
          path: ':subedition',
          name: 'assetChild1',
          components: {
            view: () => import('./views/EditionSection')
          },

          meta: {
            isEdition: 'asset',
            requiresUserAuth: true,
            requiresAcademyAuth: true
          }
        },

        {
          path: ':subid/:subedition',
          name: 'assetChild2',
          components: {
            view: () => import('./views/EditionSection')
          },

          meta: {
            isEdition: 'asset',
            requiresUserAuth: true,
            requiresAcademyAuth: true
          }
        }
      ],

      components: {
        view: () => import('./views/EditionSection')
      },

      meta: {
        isEdition: 'asset',
        requiresUserAuth: true,
        requiresAcademyAuth: true
      }
    },

    {
      path: `/${i18n.t('rPaths.billing')}/:subject`,
      name: 'billing',

      // Children routes
      children: [
        {
          path: ':subedition',
          name: 'billingChild1',
          components: {
            view: () => import('./views/EditionSection')
          },

          meta: {
            isEdition: 'billing',
            requiresUserAuth: true,
            requiresAcademyAuth: true
          }
        },

        {
          path: ':subid/:subedition',
          name: 'billingChild2',
          components: {
            view: () => import('./views/EditionSection')
          },

          meta: {
            isEdition: 'billing',
            requiresUserAuth: true,
            requiresAcademyAuth: true
          }
        },

        {
          path: ':subid/:subedition/:thirdid',
          name: 'billingChild3',
          components: {
            view: () => import('./views/EditionSection')
          },

          meta: {
            isEdition: 'billing',
            requiresUserAuth: true,
            requiresAcademyAuth: true
          }
        }
      ],

      components: {
        view: () => import('./views/EditionSection')
      },

      meta: {
        isEdition: 'billing',
        requiresUserAuth: true,
        requiresAcademyAuth: true
      }
    },

    {
      path: `/${i18n.t('rPaths.initialAccess')}`,
      name: 'initialAccess',

      components: {
        view: () => import('./views/InitialAccess')
      },

      meta: {
        requiresUserAuth: true,
        requiresAcademyAuth: false
      }
    },

    {
      path: `/${i18n.t('rPaths.initialSetup')}/:id`,
      name: 'initialSetup',

      components: {
        view: () => import('./views/InitialSetup')
      },

      meta: {
        requiresUserAuth: true,
        requiresAcademyAuth: false
      }
    },

    {
      path: `/${i18n.t('rPaths.confirmForgotPassword')}`,
      name: 'confirmForgotPassword',

      components: {
        view: () => import('./views/ConfirmForgotPassword')
      },

      meta: {
        requiresUserAuth: false,
        requiresAcademyAuth: false
      }
    },

    {
      path: encodeURI(`/${i18n.t('rPaths.confirmForgotPassword')}`),
      name: 'confirmForgotPassword',

      components: {
        view: () => import('./views/ConfirmForgotPassword')
      },

      meta: {
        requiresUserAuth: false,
        requiresAcademyAuth: false
      }
    },

    {
      path: encodeURI(`/${i18n.t('rPaths.forgetPassword')}`),
      name: 'forgetPassword',

      components: {
        view: () => import('./views/ForgetPassword')
      },

      meta: {
        requiresUserAuth: false,
        requiresAcademyAuth: false
      }
    },

    {
      path: `/${i18n.t('rPaths.forgetPassword')}`,
      name: 'forgetPassword',

      components: {
        view: () => import('./views/ForgetPassword')
      },

      meta: {
        requiresUserAuth: false,
        requiresAcademyAuth: false
      }
    },

    {
      path: `/${i18n.t('rPaths.login')}`,
      name: 'userLogin',

      components: {
        view: () => import('./views/Login')
      },

      meta: {
        requiresUserAuth: false,
        requiresAcademyAuth: false
      }
    },

    {
      path: `/${i18n.t('rPaths.clearCache')}`,
      name: 'clearCache',

      components: {
        view: () => import('./views/ClearCache')
      },

      meta: {
        requiresUserAuth: false,
        requiresAcademyAuth: false
      }
    },

    {
      path: '/logout',
      name: 'logout',

      components: {
        view: () => import('./views/LogOut')
      },

      meta: {
        requiresUserAuth: false,
        requiresAcademyAuth: false
      }
    },

    {
      path: '/reset-password',
      name: 'resetPassword',

      components: {
        view: () => import('./views/ResetPassword')
      },

      meta: {
        requiresUserAuth: false,
        requiresAcademyAuth: false
      }
    },

    {
      path: `/${i18n.t('rPaths.map')}/:id/:subject`,
      name: 'map',

      // Children routes
      children: [
        {
          path: ':subedition',
          name: 'mapChild1',
          components: {
            view: () => import('./views/EditionSection')
          },

          meta: {
            isEdition: 'map',
            requiresUserAuth: true,
            requiresAcademyAuth: true
          }
        },

        {
          path: ':subid/:subedition',
          name: 'mapChild2',
          components: {
            view: () => import('./views/EditionSection')
          },

          meta: {
            isEdition: 'map',
            requiresUserAuth: true,
            requiresAcademyAuth: true
          }
        }
      ],

      components: {
        view: () => import('./views/EditionSection')
      },

      meta: {
        isEdition: 'map',
        requiresUserAuth: true,
        requiresAcademyAuth: true
      }
    },

    {
      path: `/${i18n.t('rPaths.notFound')}`,
      name: 'notFound',

      components: {
        view: () => import('./views/NotFound')
      },

      meta: {
        requiresUserAuth: true,
        requiresAcademyAuth: true
      }
    },

    {
      path: `/${i18n.t('rPaths.product')}/:id/:subject`,
      name: 'product',

      // Children routes
      children: [
        {
          path: ':subedition',
          name: 'productChild1',
          components: {
            view: () => import('./views/EditionSection')
          },

          meta: {
            isEdition: 'product',
            requiresUserAuth: true,
            requiresAcademyAuth: true
          },

          props: true
        },

        {
          path: ':subid/:subedition',
          name: 'productChild2',
          components: {
            view: () => import('./views/EditionSection')
          },

          meta: {
            isEdition: 'product',
            requiresUserAuth: true,
            requiresAcademyAuth: true
          },

          props: true
        }
      ],

      components: {
        view: () => import('./views/EditionSection')
      },

      meta: {
        isEdition: 'product',
        requiresUserAuth: true,
        requiresAcademyAuth: true
      }
    },

    {
      path: `/${i18n.t('rPaths.products')}`,
      name: 'products',

      components: {
        view: () => import('./views/FeedSection')
      },

      meta: {
        isEdition: 'products',
        requiresUserAuth: true,
        requiresAcademyAuth: true
      }
    },

    {
      path: `/${i18n.t('rPaths.projects')}`,
      name: 'projects',

      components: {
        view: () => import('./views/FeedSection')
      },

      meta: {
        isEdition: 'projects',
        requiresUserAuth: true,
        requiresAcademyAuth: true
      }
    },

    {
      path: `/${i18n.t('rPaths.updateMyPlan')}`,
      name: 'landingUpgradePlan',

      components: {
        view: () => import('./views/LandingUpgradePlan')
      },

      meta: {
        requiresUserAuth: true,
        requiresAcademyAuth: true
      }
    },

    {
      path: '*',
      redirect: { name: 'notFound' }
    }
  ],

  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (!to.meta.requiresUserAuth ||
      (router.app.$auth.isUserAuthenticated() && !to.meta.requiresAcademyAuth && permissions.can('access', to.name)) ||
      (router.app.$auth.isUserAuthenticated() && router.app.$auth.isAcademyAuthenticated() && permissions.can('access', to.name))) {
    if (store.getters.getExitEdition) {
      store.commit('setExitEditionRoute', { edition: true, from: from, to: to })
    } else {
      next()
    }
  } else if (router.app.$auth.isUserAuthenticated() && !permissions.can('access', to.name)) {
    router.push({ name: 'accessDenied' })
  } else {
    router.app.$auth.login()
  }
})

export default router
